import { DoubleMaterialityAssessmentData } from '@apps/materiality-tracker/api/materiality-assessment';
import { Loader } from '@g17eco/atoms/loader';
import Chart from 'react-google-charts';
import './styles.scss';
import variables from '../../../../css/variables.module.scss';
import { BasicAlert } from '@g17eco/molecules/alert';
import { NOT_FOUND_CATEGORY_MESSAGE } from './utils';
import {
  chartStyles,
  chartConfigs,
  DEFAULT_CHART_COLORS,
  getChartEvents,
  LegendType,
  MATERIALITY_CHART_COLORS,
  getChartColumnColor,
  CHART_TICKS,
} from './chart-utils';
import { DoubleMaterialityChartLegend } from './partials/DoubleMaterialityChartLegend';

const WIDTH = '100%';
const HEIGHT = 480;
const COLUMN_WIDTH = '93%';

export const StackedBarChart = ({
  data,
  selectedTopicCode,
  columnClickHandler,
  category,
}: {
  data: DoubleMaterialityAssessmentData[];
  selectedTopicCode: string;
  columnClickHandler: (index: number) => void;
  category: LegendType;
}) => {
  const config = chartConfigs.find((config) => config.code === category);

  if (!config) {
    return <BasicAlert type='warning'>{NOT_FOUND_CATEGORY_MESSAGE}</BasicAlert>;
  }

  const selectedIndex = data.findIndex((topic) => topic.code === selectedTopicCode);
  const chartColors = category === LegendType.Materiality ? MATERIALITY_CHART_COLORS : DEFAULT_CHART_COLORS;

  const chartData = [
    ['Topic', 'Financial', { role: 'style' }, 'Impact', { role: 'style' }],
    ...data.map((topic, index) => {
      const color = getChartColumnColor(topic, config, category);
      return [
        topic.name,
        topic.financialRelativeScore ?? NaN,
        `${color}; ${selectedIndex === index ? 'opacity: 1' : 'opacity: 0.25'}`,
        topic.nonFinancialRelativeScore ?? NaN,
        `${color}; ${selectedIndex === index ? 'opacity: 0.5' : 'opacity: 0.25'}`,
      ];
    }),
  ];

  const chartEvents = getChartEvents(columnClickHandler);

  return (
    <div className='assessment__insights-chart mt-3'>
      <DoubleMaterialityChartLegend config={config} chartColors={chartColors} />
      <Chart
        chartType='ColumnChart'
        data={chartData}
        chartEvents={chartEvents}
        loader={<Loader />}
        options={{
          bar: {
            groupWidth: COLUMN_WIDTH,
          },
          chartArea: { ...chartStyles.chartArea, top: 10, bottom: 10, left: 40, height: HEIGHT },
          hAxis: {
            textPosition: 'none',
          },
          vAxis: {
            ...chartStyles.axis,
            title: 'TOTAL TOPIC SCORE',
            textPosition: 'out',
            ticks: CHART_TICKS,
            gridlines: {
              color: 'transparent',
            },
          },
          legend: 'none',
          baselineColor: variables.BgExtralight,
          isStacked: true,
        }}
        width={WIDTH}
        height={HEIGHT}
      />
    </div>
  );
};
